// extracted by mini-css-extract-plugin
module.exports = {"container":"fdoZed_1_PwBXCyr5mdTB"};